import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import ue from "../models/braze-event.js";
import _t from "../models/identifier.js";
import { convertMsToSeconds as X } from "../util/date-utils.js";
import {
  logger as N,
  Guid as O,
  EventTypes as d,
} from "../../shared-lib/index.js";
export default class Kt {
  constructor(s, t, i, e) {
    (this.C = s),
      (this.Cs = t),
      (this.B = i),
      (this.Su = e),
      (this.C = s),
      (this.Cs = t),
      (this.B = i),
      (this.ju = 1e3),
      (null == e || isNaN(e)) && (e = 1800),
      e < this.ju / 1e3 &&
        (N.info(
          "Specified session timeout of " +
            e +
            "s is too small, using the minimum session timeout of " +
            this.ju / 1e3 +
            "s instead.",
        ),
        (e = this.ju / 1e3)),
      (this.Su = e);
  }
  xu(s, t) {
    return new ue(this.Cs.getUserId(), d.Du, s, t.eu, { d: X(s - t.Gu) });
  }
  St() {
    const t = this.C.tu(s.iu.Nu);
    return null == t ? null : t.eu;
  }
  zu() {
    const t = new Date().valueOf(),
      i = this.B.yu();
    if (null == i) return !1;
    const e = this.C.ft(s.gt.Hu),
      n = null == e || t - e > 1e3 * i;
    return n && this.C.Bt(s.gt.Hu, t), n;
  }
  Wu(s, t) {
    return null == t || null == t.ku || (!(s - t.Gu < this.ju) && t.ku < s);
  }
  Vo() {
    const t = new Date().valueOf(),
      i = t + 1e3 * this.Su,
      e = this.C.tu(s.iu.Nu);
    if (this.Wu(t, e)) {
      let n = "Generating session start event with time " + t;
      if (null != e) {
        let s = e.qu;
        s - e.Gu < this.ju && (s = e.Gu + this.ju),
          this.C.Au(this.xu(s, e)),
          (n += " (old session ended " + s + ")");
      }
      (n += ". Will expire " + i.valueOf()), N.info(n);
      const o = new _t(O.ce(), i);
      this.C.Au(new ue(this.Cs.getUserId(), d.Iu, t, o.eu)),
        this.C.uu(s.iu.Nu, o);
      return null == this.C.ft(s.gt.Hu) && this.C.Bt(s.gt.Hu, t), o.eu;
    }
    if (null != e) return (e.qu = t), (e.ku = i), this.C.uu(s.iu.Nu, e), e.eu;
  }
  Ju() {
    const t = this.C.tu(s.iu.Nu);
    null != t &&
      (this.C.Ku(s.iu.Nu), this.C.Au(this.xu(new Date().valueOf(), t)));
  }
}
